<template>
  <div class="app-splash">
    <img alt="Logo" class="size-32 animate-bounce select-none" src="/icon.png" />
  </div>
</template>

<style lang="scss">
.app-splash {
  @apply h-screen w-screen flex flex-col items-center justify-center;
  background-color: #0b3d3a;
}
</style>
